export const visit = (vm, at) => {
vm(require("./availability/zh-tw.lyaml"));
vm(require("./typical-response-time/zh-tw.lyaml"));
vm(require("./default/zh-tw.lyaml"));
at({ "zh-tw": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "\u78BA\u5B9A" } } });
};